import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import Select from 'react-select'
import Axios from "axios"
import car_data from "../Data/car_data.json"
import unknown_car from "../Data/sample_images/unknown_car.png"

const Quote = () => {
    //   state to store the user's input
    const [personalInput, setPersonalInput] = useState({
        name: '',
        age: null,
        drivingYears: null,
        chooseRegion: '',
        driveway: '',
        ncb: null
    })
    const [carInput, setCarInput] = useState({}),
        [invalid, setInvalid] = useState(true),
        [errorMessage, setErrorMessage] = useState("Type your details below:"),
        [show, setShow] = useState(true),
        // STATE FOR NodeJS/SQL OUTPUT
        [multiplier, setMultiplier] = useState(null)

    // Formula to calculate user's premium quote
    const quote = parseFloat(multiplier * carInput.base_insurance).toFixed(2)

    //   Function to handle form
    const handlePersonalForm = (event) => {
        event.preventDefault()
        setPersonalInput((prevInput) => {
            return {
                ...prevInput,
                [event.target.name]: event.target.type === "checkbox" ? event.target.checked : event.target.value
            }
        })
    }
    
    //   Function to handle form
    const handleCarForm = (event) => {
        event.preventDefault()
        setCarInput((prevInput) => {
            return {
                ...prevInput,
                [event.target.name]: event.target.type === "checkbox" ? event.target.checked : event.target.value
            }
        })
    }

    // RegEx to ensure user enters valid information
    const checkName = () => {
        setShow(true)
        // RegEx to check if Name is 3-80 normal letters long, incl. spacebar.
        let regExName = /^[a-zA-Z .-]{3,80}$/,
        // RegEx to check if age is < 100. 
            regExAge = /^\d{1,2}$/,
        // RegEx to check if NCB & drivingYears is a digit. 
            regExNCB = /^\d{1}$/
        if (personalInput.name == '' || personalInput.age < 0 || !personalInput.age || personalInput.drivingYears < 0 || personalInput.ncb < 0) {
            setInvalid(true)
            return setErrorMessage("Your details are not valid. Please try again.")
        }
        else if (!regExName.test(personalInput.name)) {
            setInvalid(true)
            return setErrorMessage("Please enter a name between 2-80 characters")
        }
        else if (!regExAge.test(personalInput.age)) {
            setInvalid(true)
            return setErrorMessage("Please enter an age bwtween 17 - 99")
        }
        else if (!regExNCB.test(personalInput.ncb)) {
            setInvalid(true)
            return setErrorMessage("Please enter a valid NCB (if you have 9+ years of NCB, write down 9).")
        }
        else if (!regExNCB.test(personalInput.drivingYears)) {
            setInvalid(true)
            return setErrorMessage("Please enter a number between 0-9 for driving experience (if you have 9+ years of driving experience, write down 9).")
        }
        else if (parseInt(personalInput.age) < 17) {
            setInvalid(true)
            return setErrorMessage("ERROR: You are too young to drive. You must be 18+ years old to rent a vehicle.")
        }
        else {
            setInvalid(false)
            return setErrorMessage("Thanks!")
        }
    }

    // Function to show alert for valid/invalid user entry
    useEffect(() => {
        const showMessage = setTimeout(() => {
            setShow(false)
        }, 4000)
        return () => {
            clearTimeout(showMessage)
        }
    }, [personalInput, invalid])

    // Function to reset all states
    const resetState = () => {
        return window.location.reload()
    }
    
    // Function to make post & get request to backend with Axios
    const getQuote = () => {
        Axios.post('https://autoinsure.onrender.com/create', {
            name: personalInput.name,
            age: personalInput.age,
            drivingYears: personalInput.drivingYears,
            chooseRegion: personalInput.chooseRegion,
            driveway: personalInput.driveway,
            ncb: personalInput.ncb,
            insuranceGroup: carInput.insurance_group
        }).then(() => console.log("worked"))

        Axios.get('https://autoinsure.onrender.com/result')
            .then((response) => setMultiplier(response.data[0].multiplier))
    }

  return (
    <>
        <section className='quote'>
            <div className="container quote-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Get A Quote</h1>
                <p className="section-caption">Get a quick Car Insurance Premium Quote, using real-time data. Type in your personal data, and select the car of your choice to attain a premium prediction.</p>
                <div className="quote-form">
                    <h2 className="personal-details-title">Personal Details</h2>
                    <div className="personal-details">
                        <div className={`is-valid ${invalid ? "danger" : "success"} ${!show && "hide"}`}>{errorMessage}</div>
                        <form className='personal-details-form' autoComplete='off' onSubmit={handlePersonalForm}>
                            <div className="quote-form-group">
                                <input type="text" id='name' name='name' value={personalInput.name} placeholder='Full Name' onChange={(event) => handlePersonalForm(event)}/>
                            </div>
                            <div className="quote-form-group">
                                <input type="number" id='age' name='age' value={personalInput.age} placeholder='Current Age' onChange={(event) => handlePersonalForm(event)}/>
                            </div>
                            <div className="quote-form-group">
                                <input type="number" id="driving-years-input" name='drivingYears' value={personalInput.drivingYears} placeholder='How Long have you owned your Full Driving License (years)?' onChange={(event) => handlePersonalForm(event)} />
                            </div>
                            <div className="quote-form-group">
                                <select id="chooseRegion" name='chooseRegion' value={personalInput.chooseRegion} onChange={(event) => handlePersonalForm(event)} >
                                    <option value="">What Region of the UK do you live in?</option>
                                    <option value="london">London</option>
                                    <option value="south-east">South-East</option>
                                    <option value="south-west">South-West</option>
                                    <option value="east-of-england">East Of England</option>
                                    <option value="east-midlands">East Midlands</option>
                                    <option value="west-midlands">West Midlands</option>
                                    <option value="yorkshire">Yorkshire and The Humber</option>
                                    <option value="north-west">North West</option>
                                    <option value="north-east">North East</option>
                                    <option value="wales">Wales</option>
                                    <option value="scotland">Scotland</option>
                                </select>
                            </div>      
                            <div className="quote-form-group">
                                <select id="chooseDriveway" name="driveway" value={personalInput.driveway} onChange={(event) => handlePersonalForm(event)} >
                                    <option value="">Does your address have a driveway?</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                </select>
                            </div>
                            <div className="quote-form-group">
                                <input type="number" id='NCB' name='ncb' value={personalInput.ncb} placeholder='No Claims Bonus (years)' onChange={(event) => handlePersonalForm(event)}/>
                            </div>
                        </form>
                        <button className="btn btn-lg next-btn" onClick={() => checkName()}>Next</button>
                    </div>
                    <h2 className={!invalid ? "car-details-title" : "hide"}>Car Details</h2>
                    <div className={!invalid ? "car-details" : "hide"}>
                        <div className="quote-img-container">
                            <img src={carInput.img ? carInput.img : unknown_car} alt="Car" />
                        </div>
                        <form className="car-details-form" onSubmit={handleCarForm}>
                            <Select 
                                options={car_data}
                                id="chooseMake"
                                onChange={setCarInput}
                                isSearchable
                                getOptionLabel={(option) => `${option.make} ${option.model} ${option.year}`}
                            />
                        </form>
                    </div>
                    <button className={!invalid && !multiplier ? "btn btn-lg get-quote" : "hide"} onClick={() => getQuote()}>Get Quote</button>
                </div>
                <div className={invalid || !multiplier ? "hide" : "quote-results"}>
                    <h1 className="quote-results-title">Your Premium:</h1>
                    <div className='right'>
                        <h1 className="annual-premium-title">{`£${quote}`}</h1>
                        per year
                        <h4 className="monthly-premium-title">Your Monthly Premium:</h4>
                        12 x <span className="monthly-premium">{`£${(quote/12).toFixed(2)}`}</span> per month
                    </div>
                </div>
                <div className={invalid || !multiplier ? "hide" : "quote-btn-container"}>
                    <Link to="/checkout">
                        <button className='btn btn-lg checkout-btn'>Checkout</button>
                    </Link>
                    <Link to="/getaquote">
                        <button className="btn btn-lg btn-light new-quote" onClick={() => resetState()}>New Quote</button>
                    </Link>
                </div>
            </div>
        </section>
    </>
  )
}

export default Quote
